/**
 * Генерирует превью для видеофайла
 * @param videoFile Видеофайл
 * @param timeInSeconds Время в секундах для захвата кадра
 * @returns Promise с Blob превью в формате JPEG
 */
export function generateVideoThumbnail(
  videoFile: File,
  timeInSeconds: number = 5
): Promise<Blob> {
  return new Promise((resolve, reject) => {
    // Создаем элементы
    const video = document.createElement('video');
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    if (!ctx) {
      reject(new Error('Не удалось получить контекст canvas'));
      return;
    }

    const videoUrl = URL.createObjectURL(videoFile);

    video.onloadedmetadata = () => {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      
      // Устанавливаем время
      video.currentTime = Math.min(timeInSeconds, video.duration / 2);
    };
    
    video.onseeked = () => {
      // Рисуем кадр на canvas
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      
      // Освобождаем ресурсы
      URL.revokeObjectURL(videoUrl);

      canvas.toBlob(
        (blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error('Не удалось создать превью'));
          }
        },
        'image/jpeg',
        0.1 // качество
      );
    };

    video.onerror = () => {
      URL.revokeObjectURL(videoUrl);
      reject(new Error('Ошибка загрузки видео'));
    };

    video.src = videoUrl;
    video.load();
  });
}
